/** @constructor */
export class Label {
  constructor(
    public name: string,
    public codeOffset: number,
    public dataOffset: number
  ) {
    // this.name = name;
    // this.codeOffset = codeOffset;
    // this.dataOffset = dataOffset;
  }
}
